import { render, staticRenderFns } from "./LavoroSquadra.vue?vue&type=template&id=76625bca&scoped=true&"
import script from "./LavoroSquadra.vue?vue&type=script&lang=js&"
export * from "./LavoroSquadra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76625bca",
  null
  
)

export default component.exports